<script setup lang="ts">
import { tw } from "../../../utils/tailwind";
import type { WithClassAsProps } from "./interface";
import { useCarousel } from "./useCarousel";

const props = defineProps<WithClassAsProps>();

const { orientation } = useCarousel();
</script>

<template>
  <div
    role="group"
    aria-roledescription="slide"
    :class="tw(
      'min-w-0 shrink-0 grow-0 basis-full',
      orientation === 'horizontal' ? '' : 'pt-4',
      props.class,
    )"
  >
    <slot />
  </div>
</template>
